import React from 'react';
import { Box, Skeleton, Stack, TableRow, TableCell } from '@mui/material';

export const KpiSkeleton: React.FC = () => (
  <Box sx={{ p: 1.5, borderRadius: 2, border: '1px solid', borderColor: 'divider', minHeight: 80 }}>
    <Skeleton variant="text" width="40%" height={14} />
    <Skeleton variant="text" width="70%" height={28} sx={{ mt: 0.5 }} />
    <Skeleton variant="text" width="30%" height={12} sx={{ mt: 0.25 }} />
  </Box>
);

export const CardSkeleton: React.FC<{ rows?: number; height?: number }> = ({ rows = 3, height }) => (
  <Box sx={{ p: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider', height }}>
    <Skeleton variant="text" width="35%" height={20} />
    <Stack spacing={0.75} sx={{ mt: 1 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="rectangular" height={28} sx={{ borderRadius: 0.5 }} />
      ))}
    </Stack>
  </Box>
);

export const TableRowSkeleton: React.FC<{ columns: number }> = ({ columns }) => (
  <TableRow>
    {Array.from({ length: columns }).map((_, i) => (
      <TableCell key={i}>
        <Skeleton variant="text" />
      </TableCell>
    ))}
  </TableRow>
);

export const TableSkeleton: React.FC<{ rows?: number; columns: number }> = ({ rows = 6, columns }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <TableRowSkeleton key={i} columns={columns} />
    ))}
  </>
);

export const ListItemSkeleton: React.FC<{ avatar?: boolean }> = ({ avatar = true }) => (
  <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', py: 1 }}>
    {avatar && <Skeleton variant="circular" width={32} height={32} />}
    <Box sx={{ flexGrow: 1 }}>
      <Skeleton variant="text" width="60%" height={16} />
      <Skeleton variant="text" width="40%" height={12} />
    </Box>
    <Skeleton variant="rectangular" width={56} height={24} sx={{ borderRadius: 0.5 }} />
  </Box>
);

export const ListSkeleton: React.FC<{ count?: number; avatar?: boolean }> = ({ count = 4, avatar }) => (
  <Stack divider={<Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }} />}>
    {Array.from({ length: count }).map((_, i) => (
      <ListItemSkeleton key={i} avatar={avatar} />
    ))}
  </Stack>
);
